import { render } from "./KOLKeywordSetting.vue?vue&type=template&id=7b4fcf7c"
import script from "./KOLKeywordSetting.vue?vue&type=script&lang=js"
export * from "./KOLKeywordSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__